import styled from "styled-components";
import { FilterStatus } from "../../../config/appliedFilters";

export const DateRangeFilterContainer = styled.div`
  .k-textbox-container {
    width: 137px !important;
  }

  .k-textbox-container + .k-textbox-container {
    margin-left: 30px !important;
  }
`;

export const ExternalFilterContainer = styled.div`
  padding-top: 10px;
`;

export const FilterButton = styled.button`
  && {
    padding: 6.5px 12px;
    margin-right: 5px;
  }
  
  font-size: 100%;
`;

export const LAPTOP_MEDIA = "(min-width: 1024px) and (max-width: 1440px) and (pointer: fine)";

export const filterGroupClass = (status: FilterStatus) => `ax-filter-group${status === "off" ? "" : ` o360-filter-${status}`}`;

export const FiltersPanel = styled.div`
  && .o360-filter-on > .ax-filter-group-label {
    color: var(--ax-accent-on-tint);
    font-weight: var(--ax-fw-semibold);
  }

  && .o360-filter-on > .ax-filter-group-label::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 6px;
    border-radius: 50%;
    background: var(--ax-accent-500);
    vertical-align: 1px;
  }

  && .o360-filter-on .ax-combobox:not(.is-open) > .ax-combobox-control,
  && .o360-filter-on .ax-form-control {
    background: var(--ax-accent-tint);
  }

  && .o360-filter-on .ax-combobox:not(.is-open) > .ax-combobox-control:hover {
    background: var(--ax-accent-tint-strong);
  }

  && .o360-filter-on .ax-combobox-control:not(:focus-within),
  && .o360-filter-on .ax-form-control:not(:focus) {
    border-color: var(--ax-accent-soft);
  }

  && .o360-filter-on .ax-combobox-input,
  && .o360-filter-on .ax-form-control {
    color: var(--ax-accent-on-tint);
    font-weight: var(--ax-fw-medium);
  }

  && .o360-filter-pending > .ax-filter-group-label {
    display: flex;
    align-items: center;
    color: var(--ax-warning-on-tint);
    font-weight: var(--ax-fw-semibold);
  }

  && .o360-filter-pending > .ax-filter-group-label::before,
  && .o360-filters-pending::before {
    content: "";
    flex: none;
    width: 6px;
    height: 6px;
    margin-right: 6px;
    border-radius: 50%;
    box-shadow: inset 0 0 0 1.5px var(--ax-warning);
  }

  && .o360-filter-pending > .ax-filter-group-label::after {
    content: "sin aplicar";
    margin-left: auto;
    font-size: var(--ax-font-size-xs);
    font-weight: var(--ax-fw-medium);
  }

  && .o360-filter-pending .ax-combobox:not(.is-open) > .ax-combobox-control,
  && .o360-filter-pending .ax-form-control {
    background: var(--ax-warning-tint);
  }

  && .o360-filter-pending .ax-combobox:not(.is-open) > .ax-combobox-control:hover {
    background: var(--ax-warning-tint-strong);
  }

  && .o360-filter-pending .ax-combobox-control:not(:focus-within),
  && .o360-filter-pending .ax-form-control:not(:focus) {
    border-style: dashed;
    border-color: rgba(var(--ax-warning-rgb), 0.65);
  }

  && .o360-filter-pending .ax-combobox-input,
  && .o360-filter-pending .ax-form-control {
    color: var(--ax-warning-on-tint);
    font-weight: var(--ax-fw-medium);
  }

  .o360-filters-footer {
    flex: none;
    padding: var(--ax-space-3) var(--ax-space-4) var(--ax-space-4);
    border-top: 1px solid var(--ax-separator);
  }

  .o360-filters-pending {
    display: flex;
    align-items: center;
    margin: 0 0 var(--ax-space-2);
    color: var(--ax-warning-on-tint);
    font-size: var(--ax-font-size-sm);
    font-weight: var(--ax-fw-medium);
  }

  .o360-filters-pending > .ax-btn-link {
    height: auto;
    margin-left: auto;
    padding: 0;
  }

  @media ${LAPTOP_MEDIA} {
    .o360-filters-footer {
      padding: var(--ax-space-3);
    }
  }
`;

export const FiltersTrigger = styled.button`
  &&.is-pending::before {
    content: "";
    position: absolute;
    top: -3px;
    right: -3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--ax-warning);
    box-shadow: 0 0 0 2px var(--ax-view-canvas);
  }
`;
